import { EntitiesServiceInterface } from 'domain/services';
import {
  AddCourseToEntityUseCaseInterface,
  AddPersonToEntityUseCaseInterface,
  ChangeSemesterOrderUseCaseInterface,
  CreateSemesterUseCaseInterface,
  DeleteSemesterUseCaseInterface,
  GetAllCoursesFromEntityUseCaseInterface,
  GetCourseSettingsFromEntityUseCaseInterface,
  GetAllEntitiesUseCaseInterface,
  GetAllNomenclaturesFromEntityUseCaseInterface,
  GetAllPersonsFromEntityUseCaseInterface,
  GetAllSemestersFromEntityUseCaseInterface,
  GetPersonByCPFUseCaseInterface,
  GetSemesterByIdUseCaseInterface,
  UnlinkCourseFromEntityUseCaseInterface,
  UnlinkPersonFromEntityUseCaseInterface,
  UpdateCourseFromEntityUseCaseInterface,
  UpdateNomenclaturesFromEntityUseCaseInterface,
  UpdateSemesterUseCaseInterface,
  CreateEntitiesUseCaseInterface,
  DeleteEntitiesUseCaseInterface,
  GetByIdEntitiesUseCaseInterface,
  UpdateEntitiesUseCaseInterface,
  StudentsCountUseCaseInterface,
  PositionCountForEntityUseCaseInterface,
  GroupsCountUseCaseInterface,
  OngoingActivitiesByCourseUseCaseInterface,
  StudentsRegisteredForOrganizationUseCaseInterface,
  GetAllEntitiesByPersonUseCaseInterface,
  UploadBannerUseCaseInterface,
  DeleteBannerUseCaseInterface,
  DeletePhotoUseCaseInterface,
  UploadPhotoUseCaseInterface,
  GetEntityTceCountUseCaseInterface,
  GetEntityTerminationTermCountUseCaseInterface,
  CreateFieldAssessmentsUseCaseInterface,
  DeleteFieldAssessmentsUseCaseInterface,
  GetAllFieldAssessmentsUseCaseInterface,
  GetByIdFieldAssessmentsUseCaseInterface,
  UpdateFieldAssessmentsUseCaseInterface,
  GetPaginatedOrganizationStudentsWithoutTceUseCaseInterface,
  GetPaginatedOrganizationTcesDraftsUseCaseInterface,
  GetPaginatedOrganizationTcesWaitingStudentSignatureUseCaseInterface,
  GetPaginatedOrganizationTcesWaitingGrantorSignatureUseCaseInterface,
  GetPaginatedOrganizationTcesWaitingInstitutionSignatureUseCaseInterface,
  GetPaginatedOrganizationActiveTcesUseCaseInterface,
  GetPaginatedOrganizationExpiredTcesUseCaseInterface,
  GetPaginatedOrganizationTcesSentToIntegrativeUseCaseInterface,
} from 'domain/usecases';

interface UseCasesInjection {
  getAllEntities: GetAllEntitiesUseCaseInterface;
  deleteEntities: DeleteEntitiesUseCaseInterface;
  updateEntities: UpdateEntitiesUseCaseInterface;
  createEntities: CreateEntitiesUseCaseInterface;
  getByIdEntity: GetByIdEntitiesUseCaseInterface;
  addCourseToEntity: AddCourseToEntityUseCaseInterface;
  addPersonTOEntity: AddPersonToEntityUseCaseInterface;
  changeSemesterOrder: ChangeSemesterOrderUseCaseInterface;
  createSemester: CreateSemesterUseCaseInterface;
  deleteSemester: DeleteSemesterUseCaseInterface;
  getAllCoursesFromEntity: GetAllCoursesFromEntityUseCaseInterface;
  getCourseSettingsFromEntity: GetCourseSettingsFromEntityUseCaseInterface;
  getAllNomenclaturesFromEntity: GetAllNomenclaturesFromEntityUseCaseInterface;
  getAllPersonsFromEntity: GetAllPersonsFromEntityUseCaseInterface;
  getAllSemestersFromEntity: GetAllSemestersFromEntityUseCaseInterface;
  getPersonByCPF: GetPersonByCPFUseCaseInterface;
  getSemesterById: GetSemesterByIdUseCaseInterface;
  unlinkCourseFromEntity: UnlinkCourseFromEntityUseCaseInterface;
  unlinkPersonFromEntity: UnlinkPersonFromEntityUseCaseInterface;
  updateCourseFromEntity: UpdateCourseFromEntityUseCaseInterface;
  updateNomenclatureFromEntity: UpdateNomenclaturesFromEntityUseCaseInterface;
  updateSemester: UpdateSemesterUseCaseInterface;
  studentsCount: StudentsCountUseCaseInterface;
  positionCountForEntity: PositionCountForEntityUseCaseInterface;
  groupsCount: GroupsCountUseCaseInterface;
  ongoingActivitiesByCourse: OngoingActivitiesByCourseUseCaseInterface;
  studentsRegisteredForOrganization: StudentsRegisteredForOrganizationUseCaseInterface;
  getAllEntitiesByPerson: GetAllEntitiesByPersonUseCaseInterface;
  uploadBanner: UploadBannerUseCaseInterface;
  deleteBanner: DeleteBannerUseCaseInterface;
  uploadPhoto: UploadPhotoUseCaseInterface;
  deletePhoto: DeletePhotoUseCaseInterface;
  getEntityTceCount: GetEntityTceCountUseCaseInterface;
  getEntityTerminationTermCount: GetEntityTerminationTermCountUseCaseInterface;
  createFieldAssessments: CreateFieldAssessmentsUseCaseInterface;
  deleteFieldAssessments: DeleteFieldAssessmentsUseCaseInterface;
  getAllFieldAssessments: GetAllFieldAssessmentsUseCaseInterface;
  getByIdFieldAssessments: GetByIdFieldAssessmentsUseCaseInterface;
  updateFieldAssessments: UpdateFieldAssessmentsUseCaseInterface;
  getPaginatedOrganizationStudentsWithoutTce: GetPaginatedOrganizationStudentsWithoutTceUseCaseInterface;
  getPaginatedOrganizationTcesDrafts: GetPaginatedOrganizationTcesDraftsUseCaseInterface;
  getPaginatedOrganizationTcesWaitingStudentSignature: GetPaginatedOrganizationTcesWaitingStudentSignatureUseCaseInterface;
  getPaginatedOrganizationTcesWaitingGrantorSignature: GetPaginatedOrganizationTcesWaitingGrantorSignatureUseCaseInterface;
  getPaginatedOrganizationTcesWaitingInstitutionSignature: GetPaginatedOrganizationTcesWaitingInstitutionSignatureUseCaseInterface;
  getPaginatedOrganizationActiveTces: GetPaginatedOrganizationActiveTcesUseCaseInterface;
  getPaginatedOrganizationExpiredTces: GetPaginatedOrganizationExpiredTcesUseCaseInterface;
  getPaginatedOrganizationTcesSentToIntegrative: GetPaginatedOrganizationTcesSentToIntegrativeUseCaseInterface;
}

export class EntitiesService implements EntitiesServiceInterface {
  private readonly _getAllEntities: GetAllEntitiesUseCaseInterface;
  private readonly _deleteEntities: DeleteEntitiesUseCaseInterface;
  private readonly _createEntities: CreateEntitiesUseCaseInterface;
  private readonly _getByIdEntities: GetByIdEntitiesUseCaseInterface;
  private readonly _updateEntities: UpdateEntitiesUseCaseInterface;
  private readonly _addCourseToEntity: AddCourseToEntityUseCaseInterface;
  private readonly _addPersonToEntity: AddPersonToEntityUseCaseInterface;
  private readonly _changeSemesterOrder: ChangeSemesterOrderUseCaseInterface;
  private readonly _createSemester: CreateSemesterUseCaseInterface;
  private readonly _deleteSemester: DeleteSemesterUseCaseInterface;
  private readonly _getAllCoursesFromEntity: GetAllCoursesFromEntityUseCaseInterface;

  private readonly _getCourseSettingsFromEntity: GetCourseSettingsFromEntityUseCaseInterface;
  private readonly _getAllNomenclaturesFromEntity: GetAllNomenclaturesFromEntityUseCaseInterface;
  private readonly _getAllPersonsFromEntity: GetAllPersonsFromEntityUseCaseInterface;
  private readonly _getAllSemestersFromEntity: GetAllSemestersFromEntityUseCaseInterface;
  private readonly _getPersonByCPF: GetPersonByCPFUseCaseInterface;
  private readonly _getSemesterById: GetSemesterByIdUseCaseInterface;
  private readonly _unlinkCourseFromEntity: UnlinkCourseFromEntityUseCaseInterface;
  private readonly _unlinkPersonFromEntity: UnlinkPersonFromEntityUseCaseInterface;
  private readonly _updateCourseFromEntity: UpdateCourseFromEntityUseCaseInterface;
  private readonly _updateNomenclatureFromEntity: UpdateNomenclaturesFromEntityUseCaseInterface;
  private readonly _updateSemester: UpdateSemesterUseCaseInterface;
  private readonly _studentsCount: StudentsCountUseCaseInterface;
  private readonly _positionCountForEntity: PositionCountForEntityUseCaseInterface;
  private readonly _groupsCount: GroupsCountUseCaseInterface;
  private readonly _ongoingActivitiesByCourse: OngoingActivitiesByCourseUseCaseInterface;
  private readonly _studentsRegisteredForOrganization: StudentsRegisteredForOrganizationUseCaseInterface;
  private readonly _getAllEntitiesByPerson: GetAllEntitiesByPersonUseCaseInterface;
  private readonly _uploadBanner: UploadBannerUseCaseInterface;
  private readonly _deleteBanner: DeleteBannerUseCaseInterface;
  private readonly _uploadPhoto: UploadPhotoUseCaseInterface;
  private readonly _deletePhoto: DeletePhotoUseCaseInterface;
  private readonly _getEntityTceCount: GetEntityTceCountUseCaseInterface;
  private readonly _getEntityTerminationTermCount: GetEntityTerminationTermCountUseCaseInterface;
  private readonly _createFieldAssessments: CreateFieldAssessmentsUseCaseInterface;
  private readonly _deleteFieldAssessments: DeleteFieldAssessmentsUseCaseInterface;
  private readonly _getAllFieldAssessments: GetAllFieldAssessmentsUseCaseInterface;
  private readonly _getByIdFieldAssessments: GetByIdFieldAssessmentsUseCaseInterface;
  private readonly _updateFieldAssessments: UpdateFieldAssessmentsUseCaseInterface;
  private readonly _getPaginatedOrganizationStudentsWithoutTce: GetPaginatedOrganizationStudentsWithoutTceUseCaseInterface;
  private readonly _getPaginatedOrganizationTcesDrafts: GetPaginatedOrganizationTcesDraftsUseCaseInterface;
  private readonly _getPaginatedOrganizationTcesWaitingStudentSignature: GetPaginatedOrganizationTcesWaitingStudentSignatureUseCaseInterface;
  private readonly _getPaginatedOrganizationTcesWaitingGrantorSignature: GetPaginatedOrganizationTcesWaitingGrantorSignatureUseCaseInterface;
  private readonly _getPaginatedOrganizationTcesWaitingInstitutionSignature: GetPaginatedOrganizationTcesWaitingInstitutionSignatureUseCaseInterface;
  private readonly _getPaginatedOrganizationActiveTces: GetPaginatedOrganizationActiveTcesUseCaseInterface;
  private readonly _getPaginatedOrganizationExpiredTces: GetPaginatedOrganizationExpiredTcesUseCaseInterface;
  private readonly _getPaginatedOrganizationTcesSentToIntegrative: GetPaginatedOrganizationTcesSentToIntegrativeUseCaseInterface;

  constructor(usecases: UseCasesInjection) {
    this._getAllEntities = usecases.getAllEntities;
    this._deleteEntities = usecases.deleteEntities;
    this._createEntities = usecases.createEntities;
    this._getByIdEntities = usecases.getByIdEntity;
    this._updateEntities = usecases.updateEntities;
    this._addCourseToEntity = usecases.addCourseToEntity;
    this._addPersonToEntity = usecases.addPersonTOEntity;
    this._changeSemesterOrder = usecases.changeSemesterOrder;
    this._createSemester = usecases.createSemester;
    this._deleteSemester = usecases.deleteSemester;
    this._getAllCoursesFromEntity = usecases.getAllCoursesFromEntity;

    this._getCourseSettingsFromEntity = usecases.getCourseSettingsFromEntity;
    this._getAllNomenclaturesFromEntity =
      usecases.getAllNomenclaturesFromEntity;
    this._getAllPersonsFromEntity = usecases.getAllPersonsFromEntity;
    this._getAllSemestersFromEntity = usecases.getAllSemestersFromEntity;
    this._getPersonByCPF = usecases.getPersonByCPF;
    this._getSemesterById = usecases.getSemesterById;
    this._unlinkCourseFromEntity = usecases.unlinkCourseFromEntity;
    this._unlinkPersonFromEntity = usecases.unlinkPersonFromEntity;
    this._updateCourseFromEntity = usecases.updateCourseFromEntity;
    this._updateNomenclatureFromEntity = usecases.updateNomenclatureFromEntity;
    this._updateSemester = usecases.updateSemester;
    this._studentsCount = usecases.studentsCount;
    this._positionCountForEntity = usecases.positionCountForEntity;
    this._groupsCount = usecases.groupsCount;
    this._ongoingActivitiesByCourse = usecases.ongoingActivitiesByCourse;
    this._studentsRegisteredForOrganization =
      usecases.studentsRegisteredForOrganization;
    this._getAllEntitiesByPerson = usecases.getAllEntitiesByPerson;
    this._uploadBanner = usecases.uploadBanner;
    this._deleteBanner = usecases.deleteBanner;
    this._uploadPhoto = usecases.uploadPhoto;
    this._deletePhoto = usecases.deletePhoto;
    this._getEntityTceCount = usecases.getEntityTceCount;
    this._getEntityTerminationTermCount =
      usecases.getEntityTerminationTermCount;
    this._createFieldAssessments = usecases.createFieldAssessments;
    this._deleteFieldAssessments = usecases.deleteFieldAssessments;
    this._getAllFieldAssessments = usecases.getAllFieldAssessments;
    this._getByIdFieldAssessments = usecases.getByIdFieldAssessments;
    this._updateFieldAssessments = usecases.updateFieldAssessments;
    this._getPaginatedOrganizationStudentsWithoutTce =
      usecases.getPaginatedOrganizationStudentsWithoutTce;
    this._getPaginatedOrganizationTcesDrafts =
      usecases.getPaginatedOrganizationTcesDrafts;
    this._getPaginatedOrganizationTcesWaitingStudentSignature =
      usecases.getPaginatedOrganizationTcesWaitingStudentSignature;
    this._getPaginatedOrganizationTcesWaitingGrantorSignature =
      usecases.getPaginatedOrganizationTcesWaitingGrantorSignature;
    this._getPaginatedOrganizationTcesWaitingInstitutionSignature =
      usecases.getPaginatedOrganizationTcesWaitingInstitutionSignature;
    this._getPaginatedOrganizationActiveTces =
      usecases.getPaginatedOrganizationActiveTces;
    this._getPaginatedOrganizationExpiredTces =
      usecases.getPaginatedOrganizationExpiredTces;
    this._getPaginatedOrganizationTcesSentToIntegrative =
      usecases.getPaginatedOrganizationTcesSentToIntegrative;
  }

  deleteEntities(
    params: DeleteEntitiesUseCaseInterface.Params,
  ): Promise<DeleteEntitiesUseCaseInterface.Result> {
    return this._deleteEntities.execute(params);
  }

  getAllEntities(): Promise<GetAllEntitiesUseCaseInterface.Result> {
    return this._getAllEntities.execute();
  }

  updateEntities(
    params: UpdateEntitiesUseCaseInterface.Params,
  ): Promise<UpdateEntitiesUseCaseInterface.Result> {
    return this._updateEntities.execute(params);
  }

  createEntities(
    params: CreateEntitiesUseCaseInterface.Params,
  ): Promise<CreateEntitiesUseCaseInterface.Result> {
    return this._createEntities.execute(params);
  }

  getByIdEntities(
    params: GetByIdEntitiesUseCaseInterface.Params,
  ): Promise<GetByIdEntitiesUseCaseInterface.Result> {
    return this._getByIdEntities.execute(params);
  }

  addCourseToEntity(
    params: AddCourseToEntityUseCaseInterface.Params,
  ): Promise<AddCourseToEntityUseCaseInterface.Result> {
    return this._addCourseToEntity.execute(params);
  }

  getAllCoursesFromEntity(
    params: GetAllCoursesFromEntityUseCaseInterface.Params,
  ): Promise<GetAllCoursesFromEntityUseCaseInterface.Result> {
    return this._getAllCoursesFromEntity.execute(params);
  }

  getCourseSettingsFromEntity(
    params: GetCourseSettingsFromEntityUseCaseInterface.Params,
  ): Promise<GetCourseSettingsFromEntityUseCaseInterface.Result> {
    return this._getCourseSettingsFromEntity.execute(params);
  }

  unlinkCourseFromEntity(
    params: UnlinkCourseFromEntityUseCaseInterface.Params,
  ): Promise<UnlinkCourseFromEntityUseCaseInterface.Result> {
    return this._unlinkCourseFromEntity.execute(params);
  }

  updateCourseFromEntity(
    params: UpdateCourseFromEntityUseCaseInterface.Params,
  ): Promise<UpdateCourseFromEntityUseCaseInterface.Result> {
    return this._updateCourseFromEntity.execute(params);
  }

  changeSemesterOrder(
    params: ChangeSemesterOrderUseCaseInterface.Params,
  ): Promise<ChangeSemesterOrderUseCaseInterface.Result> {
    return this._changeSemesterOrder.execute(params);
  }
  createSemester(
    params: CreateSemesterUseCaseInterface.Params,
  ): Promise<CreateSemesterUseCaseInterface.Result> {
    return this._createSemester.execute(params);
  }

  deleteSemester(
    params: DeleteSemesterUseCaseInterface.Params,
  ): Promise<DeleteSemesterUseCaseInterface.Result> {
    return this._deleteSemester.execute(params);
  }

  getAllSemestersFromEntity(
    params: GetAllSemestersFromEntityUseCaseInterface.Params,
  ): Promise<GetAllSemestersFromEntityUseCaseInterface.Result> {
    return this._getAllSemestersFromEntity.execute(params);
  }

  getSemesterById(
    params: GetSemesterByIdUseCaseInterface.Params,
  ): Promise<GetSemesterByIdUseCaseInterface.Result> {
    return this._getSemesterById.execute(params);
  }

  updateSemester(
    params: UpdateSemesterUseCaseInterface.Params,
  ): Promise<UpdateSemesterUseCaseInterface.Result> {
    return this._updateSemester.execute(params);
  }

  addPersonToEntity(
    params: AddPersonToEntityUseCaseInterface.Params,
  ): Promise<AddPersonToEntityUseCaseInterface.Result> {
    return this._addPersonToEntity.execute(params);
  }

  getAllPersonsFromEntity(
    params: GetAllPersonsFromEntityUseCaseInterface.Params,
  ): Promise<GetAllPersonsFromEntityUseCaseInterface.Result> {
    return this._getAllPersonsFromEntity.execute(params);
  }

  getPersonByCPF(
    params: GetPersonByCPFUseCaseInterface.Params,
  ): Promise<GetPersonByCPFUseCaseInterface.Result> {
    return this._getPersonByCPF.execute(params);
  }

  unlinkPersonFromEntity(
    params: UnlinkPersonFromEntityUseCaseInterface.Params,
  ): Promise<UnlinkPersonFromEntityUseCaseInterface.Result> {
    return this._unlinkPersonFromEntity.execute(params);
  }

  getAllNomenclaturesFromEntity(
    params: GetAllNomenclaturesFromEntityUseCaseInterface.Params,
  ): Promise<GetAllNomenclaturesFromEntityUseCaseInterface.Result> {
    return this._getAllNomenclaturesFromEntity.execute(params);
  }

  updateNomenclaturesFromEntity(
    params: UpdateNomenclaturesFromEntityUseCaseInterface.Params,
  ): Promise<UpdateNomenclaturesFromEntityUseCaseInterface.Result> {
    return this._updateNomenclatureFromEntity.execute(params);
  }

  studentsCount(
    params: StudentsCountUseCaseInterface.Params,
  ): Promise<StudentsCountUseCaseInterface.Result> {
    return this._studentsCount.execute(params);
  }

  positionCountForEntity(
    params: PositionCountForEntityUseCaseInterface.Params,
  ): Promise<PositionCountForEntityUseCaseInterface.Result> {
    return this._positionCountForEntity.execute(params);
  }

  groupsCount(
    params: GroupsCountUseCaseInterface.Params,
  ): Promise<GroupsCountUseCaseInterface.Result> {
    return this._groupsCount.execute(params);
  }

  ongoingActivitiesByCourse(
    params: OngoingActivitiesByCourseUseCaseInterface.Params,
  ): Promise<OngoingActivitiesByCourseUseCaseInterface.Result[]> {
    return this._ongoingActivitiesByCourse.execute(params);
  }

  studentsRegisteredForOrganization(
    params: StudentsRegisteredForOrganizationUseCaseInterface.Params,
  ): Promise<StudentsRegisteredForOrganizationUseCaseInterface.Result[]> {
    return this._studentsRegisteredForOrganization.execute(params);
  }

  getAllEntitiesByPerson(
    params: GetAllEntitiesByPersonUseCaseInterface.Params,
  ): Promise<GetAllEntitiesByPersonUseCaseInterface.Result> {
    return this._getAllEntitiesByPerson.execute(params);
  }

  uploadBanner(
    params: UploadBannerUseCaseInterface.Params,
  ): Promise<UploadBannerUseCaseInterface.Result> {
    return this._uploadBanner.execute(params);
  }

  deleteBanner(
    params: DeleteBannerUseCaseInterface.Params,
  ): Promise<DeleteBannerUseCaseInterface.Result> {
    return this._deleteBanner.execute(params);
  }

  deletePhoto(
    params: DeletePhotoUseCaseInterface.Params,
  ): Promise<DeletePhotoUseCaseInterface.Result> {
    return this._deletePhoto.execute(params);
  }

  uploadPhoto(
    params: UploadPhotoUseCaseInterface.Params,
  ): Promise<UploadPhotoUseCaseInterface.Result> {
    return this._uploadPhoto.execute(params);
  }

  getEntityTceCount(
    params: GetEntityTceCountUseCaseInterface.Params,
  ): Promise<GetEntityTceCountUseCaseInterface.Result> {
    return this._getEntityTceCount.execute(params);
  }

  getEntityTerminationTermCount(
    params: GetEntityTerminationTermCountUseCaseInterface.Params,
  ): Promise<GetEntityTerminationTermCountUseCaseInterface.Result> {
    return this._getEntityTerminationTermCount.execute(params);
  }

  createFieldAssessments(
    params: CreateFieldAssessmentsUseCaseInterface.Params,
  ): Promise<CreateFieldAssessmentsUseCaseInterface.Result> {
    return this._createFieldAssessments.execute(params);
  }

  deleteFieldAssessments(
    params: DeleteFieldAssessmentsUseCaseInterface.Params,
  ): Promise<DeleteFieldAssessmentsUseCaseInterface.Result> {
    return this._deleteFieldAssessments.execute(params);
  }

  getAllFieldAssessments(
    params: GetAllFieldAssessmentsUseCaseInterface.Params,
  ): Promise<GetAllFieldAssessmentsUseCaseInterface.Result> {
    return this._getAllFieldAssessments.execute(params);
  }

  getByIdFieldAssessments(
    params: GetByIdFieldAssessmentsUseCaseInterface.Params,
  ): Promise<GetByIdFieldAssessmentsUseCaseInterface.Result> {
    return this._getByIdFieldAssessments.execute(params);
  }

  updateFieldAssessments(
    params: UpdateFieldAssessmentsUseCaseInterface.Params,
  ): Promise<UpdateFieldAssessmentsUseCaseInterface.Result> {
    return this._updateFieldAssessments.execute(params);
  }

  getPaginatedOrganizationStudentsWithoutTce(
    params: GetPaginatedOrganizationStudentsWithoutTceUseCaseInterface.Params,
  ): Promise<GetPaginatedOrganizationStudentsWithoutTceUseCaseInterface.Result> {
    return this._getPaginatedOrganizationStudentsWithoutTce.execute(params);
  }

  getPaginatedOrganizationTcesDrafts(
    params: GetPaginatedOrganizationTcesDraftsUseCaseInterface.Params,
  ): Promise<GetPaginatedOrganizationTcesDraftsUseCaseInterface.Result> {
    return this._getPaginatedOrganizationTcesDrafts.execute(params);
  }

  getPaginatedOrganizationTcesWaitingStudentSignature(
    params: GetPaginatedOrganizationTcesWaitingStudentSignatureUseCaseInterface.Params,
  ): Promise<GetPaginatedOrganizationTcesWaitingStudentSignatureUseCaseInterface.Result> {
    return this._getPaginatedOrganizationTcesWaitingStudentSignature.execute(
      params,
    );
  }

  getPaginatedOrganizationTcesWaitingGrantorSignature(
    params: GetPaginatedOrganizationTcesWaitingGrantorSignatureUseCaseInterface.Params,
  ): Promise<GetPaginatedOrganizationTcesWaitingGrantorSignatureUseCaseInterface.Result> {
    return this._getPaginatedOrganizationTcesWaitingGrantorSignature.execute(
      params,
    );
  }

  getPaginatedOrganizationTcesWaitingInstitutionSignature(
    params: GetPaginatedOrganizationTcesWaitingInstitutionSignatureUseCaseInterface.Params,
  ): Promise<GetPaginatedOrganizationTcesWaitingInstitutionSignatureUseCaseInterface.Result> {
    return this._getPaginatedOrganizationTcesWaitingInstitutionSignature.execute(
      params,
    );
  }

  getPaginatedOrganizationActiveTces(
    params: GetPaginatedOrganizationActiveTcesUseCaseInterface.Params,
  ): Promise<GetPaginatedOrganizationActiveTcesUseCaseInterface.Result> {
    return this._getPaginatedOrganizationActiveTces.execute(params);
  }

  getPaginatedOrganizationExpiredTces(
    params: GetPaginatedOrganizationExpiredTcesUseCaseInterface.Params,
  ): Promise<GetPaginatedOrganizationExpiredTcesUseCaseInterface.Result> {
    return this._getPaginatedOrganizationExpiredTces.execute(params);
  }

  getPaginatedOrganizationTcesSentToIntegrative(
    params: GetPaginatedOrganizationTcesSentToIntegrativeUseCaseInterface.Params,
  ): Promise<GetPaginatedOrganizationTcesSentToIntegrativeUseCaseInterface.Result> {
    return this._getPaginatedOrganizationTcesSentToIntegrative.execute(params);
  }
}
